import { createFileRoute, redirect } from '@tanstack/react-router'

/** Bare /app/access has no content of its own — Users is the tab people come here for. */
export const Route = createFileRoute('/app/access/')({
  loader: () => {
    throw redirect({ to: '/app/access/users' })
  },
})
